import { useFormik } from 'formik'
import React from 'react'
import ModalComponent from '..'
import { Button } from '../../button'
import { TextInput } from '../../inputs/textInput'

import { OriginSchema } from '../../../validation/validate'
import {
  useUpdateOriginMutation,
  useAddOriginMutation,
} from '../../../redux-toolkits/origin/origin.slice'

export const AddOriginModal: React.FC<{
  open: boolean
  origin: { name: string; _id: string } | null
  setOpen: (cal: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: () => void
}> = ({
  open,
  origin,
  setOpen,
  onCloseCallback = () => {},
  onSuccessCallback = () => {},
}) => {
  const [addOrigin, { isLoading: creating }] = useAddOriginMutation()
  const [editOrigin, { isLoading: editing }] = useUpdateOriginMutation()

  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    isValid,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: {
      name: origin?.name ?? '',
    },
    enableReinitialize: true,
    validationSchema: OriginSchema,
    onSubmit: async (values) => {
      const res = origin?._id
        ? await editOrigin({ body: values, id: origin._id })
        : await addOrigin({ ...values })
      if (res.data?.success) {
        resetForm()
        setOpen(false)
        onSuccessCallback()
      }
    },
  })
  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        resetForm()
        onCloseCallback()
      }}
      title={origin?._id ? 'Edit origin' : 'Add origin'}
      childrenClassName="md:!max-w-[420px]"
    >
      <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
        <TextInput
          type="text"
          name="name"
          placeholder="Origin"
          value={values.name}
          onBlur={handleBlur}
          onChange={handleChange}
          errors={errors.name && touched.name ? errors.name : ''}
          hasIcon={false}
        />

        <Button
          label="Proceed"
          type="submit"
          className="mt-10"
          disabled={!isValid || creating}
          loading={creating || editing}
          primary
        />
      </form>
    </ModalComponent>
  )
}
